import { getConfig } from "../config.ts";

export const getEnvironment = () => {
  return getConfig().environment;
};
